
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa/treatments/[id]",
      function () {
        return require("private-next-pages/spa/treatments/[id]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa/treatments/[id]"])
      });
    }
  